<template>
    <div>
        <comp-model ref="model" title="核销码" height="auto">
            <div class="code-container" @click="focusInput">
                <div v-for="(box, index) in length" :key="index" class="code-box" :class="{ active: index === currentIndex }">
                    {{ code[index] || "" }}
                </div>
            </div>
        </comp-model>
        <!-- 隐藏实际输入框 -->
        <input ref="hiddenInput" class="hidden-input" type="text" inputmode="numeric" autocomplete="off" :maxlength="length" @input="handleInput" @keydown="handleKeyDown" />
    </div>
</template>

<script>
import compModel from "./comp-model.vue"

export default {
    name: "FullscreenCodeInput",

    components: {
        compModel,
    },

    props: {
        length: {
            type: Number,
            default: 4,
        },
    },

    data() {
        return {
            code: [],
            currentIndex: 0,
        }
    },

    methods: {
        display() {
            this.code = []
            this.currentIndex = 0
            this.$refs.hiddenInput.value = ""
            this.$refs.model.display()
            this.$nextTick(() => {
                this.focusInput()
            })
        },

        focusInput() {
            this.$refs.hiddenInput && this.$refs.hiddenInput.focus()
        },

        handleInput(e) {
            // 只允许数字
            let value = e.target.value.replace(/\D/g, "")
            this.code = value.split("").slice(0, this.length)
            this.currentIndex = this.code.length
            e.target.value = this.code.join("");

            // 输入满自动触发
            if (this.code.length === this.length) {
                const finalCode = this.code.join("")
                this.$emit("complete", {
                    tag: "comp-code-input",
                    value: finalCode,
                })
                this.$refs.model.close()
            }
        },

        handleKeyDown(e) {
            // 退格删除
            if (e.key === "Backspace" && this.code.length > 0) {
                this.code.pop()
                this.currentIndex = this.code.length
            }
        },
    },
}
</script>

<style scoped>
.code-container {
    margin: 60px 20px;
    display: flex;
    justify-content: center;
    gap: 12px;
}

.code-box {
    width: 50px;
    height: 60px;
    border: 2px solid #ddd;
    border-radius: 8px;
    font-size: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.code-box.active {
    border-color: #409eff;
}

.hidden-input {
    opacity: 0;
    position: absolute;
    pointer-events: none;
    height: 0;
}
</style>
